import { useEffect } from 'react';
import './App.css';
import './theme.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LayoutPage from './pages/LayoutPage';
import ChiSiamo from './pages/ChiSiamo';
import Contatti from './pages/Contatti';
import Squadre from './pages/Squadre';
import Regolamento from './pages/Regolamento';
import Calendario from './pages/Calendario';
import Classifiche from './pages/Classifiche';
import EdizioniPassate from './pages/EdizioniPassate';
import EdizioneDettaglio from './pages/EdizioneDettaglio';
import Partners from './pages/Partners';
import Gallery from './pages/Gallery';
import Videos from './pages/Videos';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import DynamicPage from './pages/DynamicPage';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './components/ThemeProvider';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin') || pathname.startsWith('/organizzazione');
  return (
    <>
      {!isAdmin && <Header />}
      <main className="min-h-screen">{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/chi-siamo" element={<LayoutPage slug="chi-siamo" />} />
              <Route path="/contatti" element={<LayoutPage slug="contatti" />} />
              <Route path="/squadre" element={<LayoutPage slug="squadre" />} />
              <Route path="/regolamento" element={<LayoutPage slug="regolamento" />} />
              <Route path="/calendario" element={<LayoutPage slug="calendario" />} />
              <Route path="/classifiche" element={<LayoutPage slug="classifiche" />} />
              <Route path="/partners" element={<LayoutPage slug="partners" />} />
              <Route path="/gallery" element={<LayoutPage slug="gallery" />} />
              <Route path="/video" element={<LayoutPage slug="video" />} />
              <Route path="/edizioni-passate" element={<LayoutPage slug="edizioni-passate" />} />
              <Route path="/edizioni-passate/:anno" element={<EdizioneDettaglio />} />
              <Route path="/p/:slug" element={<DynamicPage />} />
              <Route path="/admin" element={<AdminLogin mode="admin" />} />
              <Route path="/organizzazione" element={<AdminLogin mode="organizzazione" />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
